export const BOX_DETAILS_DRAWER_SCROLL_IDS = {
  BOX_DETAILS_DRAWER_SCROLL_ID_DETAILS: 'BOX_DETAILS_DRAWER_ID_DETAILS',
  BOX_DETAILS_DRAWER_SCROLL_ID_TAGS: 'BOX_DETAILS_DRAWER_ID_TAGS',
  BOX_DETAILS_DRAWER_SCROLL_ID_COMMENTS: 'BOX_DETAILS_DRAWER_ID_COMMENTS',
}
